import { apiClient } from '@/lib/apiClient';
import { useAuthStore } from '@/stores/useAuthStore';
import type { AuthResponse } from '@/lib/types/auth';

interface LoginCredentials {
    email: string;
    password: string;
}

export async function login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await apiClient<AuthResponse>('/auth/login', {
        method: 'POST',
        body: JSON.stringify(credentials),
    });

    // En cas de succès, mettre à jour le store Zustand
    useAuthStore.getState().setAuth({
        token: response.token,
        user: response.user,
        permissions: new Set(response.permissions),
    });

    // ✨ Set cookie for middleware
    document.cookie = `token=${response.token}; path=/; max-age=86400; SameSite=Strict`;

    return response;
}

export function logout() {
    useAuthStore.getState().logout();
    // ✨ Remove cookie
    document.cookie = 'token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
